import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const HowItWorksPage = lazy(() => import("../pages/how-it-works/page"));
const QuotePage = lazy(() => import("../pages/quote/page"));
const QuoteResultPage = lazy(() => import("../pages/quote-result/page"));
const BookingConfirmationPage = lazy(() => import("../pages/booking-confirmation/page"));
const CleanersPage = lazy(() => import("../pages/cleaners/page"));
const TrustSafetyPage = lazy(() => import("../pages/trust-safety/page"));
const B2BPage = lazy(() => import("../pages/b2b/page"));
const BecomeACleanerPage = lazy(() => import("../pages/become-a-cleaner/page"));
const PartnerWithUsPage = lazy(() => import("../pages/partner-with-us/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorksPage />,
  },
  {
    path: "/quote",
    element: <QuotePage />,
  },
  {
    path: "/quote-result",
    element: <QuoteResultPage />,
  },
  {
    path: "/booking-confirmation",
    element: <BookingConfirmationPage />,
  },
  {
    path: "/cleaners",
    element: <CleanersPage />,
  },
  {
    path: "/trust-safety",
    element: <TrustSafetyPage />,
  },
  {
    path: "/b2b",
    element: <B2BPage />,
  },
  {
    path: "/become-a-cleaner",
    element: <BecomeACleanerPage />,
  },
  {
    path: "/partner-with-us",
    element: <PartnerWithUsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
